var _rect, _rect2, _rect3, _g, _rect4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutsec32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 28.5,
    width: 97,
    height: 97,
    rx: 48.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 71,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#BFEEF5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 57,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#FFE5C0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_171_6082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.7141 69.9961H63.118C61.3136 69.9961 59.8457 71.464 59.8457 73.2684V81.9582C59.8457 83.7626 61.3136 85.2305 63.118 85.2305H75.7141C77.5185 85.2305 78.9863 83.7626 78.9863 81.9582V73.2684C78.9863 71.464 77.5185 69.9961 75.7141 69.9961ZM77.0332 81.9582C77.0332 82.6855 76.4414 83.2773 75.7141 83.2773H63.118C62.3906 83.2773 61.7988 82.6855 61.7988 81.9582V73.2684C61.7988 72.541 62.3906 71.9492 63.118 71.9492H75.7141C76.4414 71.9492 77.0332 72.541 77.0332 73.2684V81.9582Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.201 76.7669L68.6074 75.2696C68.3053 75.095 67.933 75.095 67.6309 75.2696C67.3287 75.444 67.1426 75.7664 67.1426 76.1153V79.11C67.1426 79.4588 67.3287 79.7813 67.6309 79.9557C67.7819 80.043 67.9505 80.0865 68.1191 80.0865C68.2878 80.0865 68.4563 80.043 68.6074 79.9557L71.201 78.4583C71.5031 78.2839 71.6893 77.9615 71.6893 77.6126C71.6893 77.2638 71.5031 76.9413 71.201 76.7669Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.474 58.0947L89.2791 51.747C88.9964 51.6 88.66 51.6 88.3773 51.747L76.182 58.0947C75.859 58.2628 75.6563 58.5967 75.6563 58.9609C75.6563 59.325 75.859 59.6589 76.182 59.8271L80.8777 62.2712V64.332H61.2773C57.6695 64.332 54.7344 67.2671 54.7344 70.875V88.9414H52.9766C52.4373 88.9414 52 89.3787 52 89.9179C52 93.4719 54.8913 96.3632 58.4453 96.3632H90.2812C93.8353 96.3632 96.7266 93.4719 96.7266 89.9179C96.7266 89.3787 96.2893 88.9414 95.75 88.9414H93.9922V70.875C93.9922 70.738 93.9863 70.6013 93.9778 70.4647L96.1838 69.5277C96.5444 69.3746 96.7786 69.0207 96.7786 68.6289V62.2712L100.047 60.5701V66.5469C100.047 67.0862 100.484 67.5235 101.023 67.5235C101.563 67.5235 102 67.0862 102 66.5469V58.9609C102 58.5966 101.797 58.2627 101.474 58.0947ZM92.0391 88.9414H78.7578C78.2186 88.9414 77.7812 89.3787 77.7812 89.9179C77.7812 90.4572 78.2186 90.8945 78.7578 90.8945H94.6665C94.2193 92.9034 92.4229 94.4101 90.2812 94.4101H58.4453C56.3036 94.4101 54.5072 92.9034 54.0601 90.8945H69.9688C70.508 90.8945 70.9453 90.4572 70.9453 89.9179C70.9453 89.3787 70.508 88.9414 69.9688 88.9414H56.6875V70.875C56.6875 68.3441 58.7465 66.2851 61.2773 66.2851H80.8777V68.6289C80.8777 69.0207 81.1118 69.3746 81.4726 69.5277L88.4465 72.4899C88.5685 72.5417 88.6983 72.5676 88.8282 72.5676C88.9581 72.5676 89.088 72.5417 89.21 72.4899L92.0391 71.2882V88.9414ZM94.8255 67.9827L88.8282 70.5301L82.8309 67.9827V63.2878L88.3773 66.1748C88.5187 66.2483 88.6734 66.2851 88.8282 66.2851C88.983 66.2851 89.1378 66.2483 89.2791 66.1748L94.8255 63.2878V67.9827ZM88.8282 64.2076L78.748 58.9609L88.8282 53.7141L98.9083 58.9609L88.8282 64.2076Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1377 58.2705C87.9561 58.4521 87.8516 58.7041 87.8516 58.9609C87.8516 59.2178 87.956 59.4697 88.1377 59.6513C88.3193 59.8329 88.5713 59.9375 88.8281 59.9375C89.085 59.9375 89.3369 59.833 89.5185 59.6513C89.7001 59.4697 89.8047 59.2178 89.8047 58.9609C89.8047 58.7041 89.7002 58.4521 89.5185 58.2705C89.3369 58.0889 89.0858 57.9844 88.8281 57.9844C88.5713 57.9845 88.3193 58.0889 88.1377 58.2705Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2956 83.2773H82.957C82.4178 83.2773 81.9805 83.7146 81.9805 84.2539C81.9805 84.7932 82.4178 85.2305 82.957 85.2305H88.2956C88.8349 85.2305 89.2722 84.7932 89.2722 84.2539C89.2722 83.7146 88.8349 83.2773 88.2956 83.2773Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2956 78.5898H82.957C82.4178 78.5898 81.9805 79.0271 81.9805 79.5664C81.9805 80.1057 82.4178 80.543 82.957 80.543H88.2956C88.8349 80.543 89.2722 80.1057 89.2722 79.5664C89.2722 79.0271 88.8349 78.5898 88.2956 78.5898Z",
    fill: "#1C3E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3633 88.9414C74.1064 88.9414 73.8545 89.0458 73.6729 89.2275C73.4912 89.4093 73.3867 89.6601 73.3867 89.918C73.3867 90.1748 73.4911 90.4268 73.6729 90.6083C73.8545 90.7899 74.1064 90.8945 74.3633 90.8945C74.6201 90.8945 74.8721 90.79 75.0536 90.6083C75.2354 90.4268 75.3398 90.1748 75.3398 89.918C75.3398 89.6611 75.2354 89.4092 75.0536 89.2275C74.8721 89.0458 74.6201 88.9414 74.3633 88.9414Z",
    fill: "#1C3E77"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 28.5,
    width: 97,
    height: 97,
    rx: 48.5,
    stroke: "#FAFAFF",
    strokeWidth: 3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_171_6082)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9094 42.2493C38.8568 42.2493 37.9534 41.983 37.1991 41.4503C36.4491 40.9134 35.8717 40.1399 35.4669 39.13C35.0663 38.1158 34.866 36.8949 34.866 35.4673C34.8703 34.0398 35.0727 32.8253 35.4733 31.8239C35.8781 30.8182 36.4555 30.0511 37.2055 29.5227C37.9598 28.9943 38.8611 28.7301 39.9094 28.7301C40.9577 28.7301 41.8589 28.9943 42.6132 29.5227C43.3675 30.0511 43.9449 30.8182 44.3454 31.8239C44.7503 32.8295 44.9527 34.044 44.9527 35.4673C44.9527 36.8991 44.7503 38.1222 44.3454 39.1364C43.9449 40.1463 43.3675 40.9176 42.6132 41.4503C41.8632 41.983 40.9619 42.2493 39.9094 42.2493ZM39.9094 40.2486C40.7275 40.2486 41.3731 39.8459 41.8461 39.0405C42.3234 38.2308 42.5621 37.0398 42.5621 35.4673C42.5621 34.4276 42.4534 33.554 42.2361 32.8466C42.0187 32.1392 41.7119 31.6065 41.3156 31.2486C40.9193 30.8864 40.4506 30.7053 39.9094 30.7053C39.0954 30.7053 38.452 31.1101 37.979 31.9197C37.5059 32.7251 37.2673 33.9077 37.2631 35.4673C37.2588 36.5114 37.3632 37.3892 37.5763 38.1009C37.7936 38.8125 38.1004 39.3494 38.4967 39.7116C38.893 40.0696 39.3639 40.2486 39.9094 40.2486ZM47.0764 42V40.2869L51.6212 35.8317C52.0558 35.3928 52.4181 35.0028 52.7078 34.6619C52.9976 34.321 53.2149 33.9908 53.3598 33.6712C53.5047 33.3516 53.5771 33.0107 53.5771 32.6484C53.5771 32.2351 53.4834 31.8814 53.2959 31.5874C53.1084 31.2891 52.8506 31.0589 52.5225 30.897C52.1943 30.7351 51.8215 30.6541 51.4039 30.6541C50.9735 30.6541 50.5963 30.7436 50.2725 30.9226C49.9486 31.0973 49.6972 31.3466 49.5182 31.6705C49.3435 31.9943 49.2561 32.38 49.2561 32.8274H46.9997C46.9997 31.9964 47.1894 31.2741 47.5686 30.6605C47.9479 30.0469 48.4699 29.5717 49.1347 29.2351C49.8037 28.8984 50.5708 28.7301 51.4358 28.7301C52.3137 28.7301 53.085 28.8942 53.7497 29.2223C54.4145 29.5504 54.9301 30 55.2966 30.571C55.6673 31.142 55.8527 31.794 55.8527 32.527C55.8527 33.017 55.759 33.4986 55.5715 33.9716C55.384 34.4446 55.0537 34.9687 54.5807 35.544C54.1119 36.1193 53.4536 36.8161 52.6056 37.6342L50.3492 39.929V40.0185H56.0509V42H47.0764Z",
    fill: "#283476"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_171_6082",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.243137 0 0 0 0 0.466667 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_6082"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_171_6082",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_171_6082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(52 49)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutsec32);
export default __webpack_public_path__ + "static/media/aboutsec32.a0f94cf8fb7d103953b1b5690d1a7fb3.svg";
export { ForwardRef as ReactComponent };